import React, { HTMLProps, useEffect } from 'react';
import { IntlShape } from 'react-intl';
import { ColumnDef, Row, Table } from '@tanstack/react-table';
import Tag from '../../components/atoms/Tag';
import { TagStatus } from '../../components/atoms/Tag/enums';
import { GetOrdersResponseSingleItem } from '../../setup/apiTypes/orders';
import { formatIqd } from '../../utils/money';
import { formatDateShort } from '../../utils/date';
import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import { useStatusOptions } from './hooks';
import { OrdersTableItem } from './types';
import Checkbox from '../../components/atoms/Fields/Checkbox';
import Badge from '../../components/atoms/Badge';
import { BadgeTone } from '../../components/atoms/Badge/enums';
import { formatIraqPhone } from '../../utils/phone';
import { cityLabel } from '../../utils/cities';

const hashHue = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  return Math.abs(h);
};

const getInitials = (name?: string): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const TableAvatar = ({ name }: { name: string }) => {
  const hue = hashHue(name);
  return (
    <span
      style={{
        width: 28, height: 28, borderRadius: '50%',
        background: `oklch(0.85 0.04 ${hue})`,
        color: `oklch(0.32 0.06 ${hue})`,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, fontWeight: 700, flexShrink: 0, lineHeight: 1,
      }}
    >
      {getInitials(name) || '·'}
    </span>
  );
};


export const ORDER_STATUS_ALL = 'all';

export const ordersTableData: OrdersTableItem[] = [
  {
    productNameCol: '6 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 60000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Warning}>Out For Delivery</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Error}>Order Resolution</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Error}>Order Resolution</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Info}>Delivered</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Warning}>Out For Delivery</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Error}>Order Resolution</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Error}>Order Resolution</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Info}>Delivered</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
  {
    productNameCol: '3 Products',
    dateCol: '01/02/2020',
    customerPhoneCol: '0345898',
    cityCol: 'Baghdad',
    receiptNoCol: '587458656',
    orderStatusCol: <Tag status={TagStatus.Success}>Placed</Tag>,
    valueIqdCol: 25000,
  },
];

function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, indeterminate]);

  return <Checkbox label='' type='checkbox' ref={ref} {...rest} />;
}

/** Map a status string to a BadgeTone (locked per spec ORDER_STATUS_TONE map) */
export const statusTone = (status: string): BadgeTone => {
  const s = status?.toLowerCase() ?? '';
  if (s.includes('delivered') || s.includes('picked')) return BadgeTone.Success;
  if (s.includes('fail') || s.includes('cancel')) return BadgeTone.Danger;
  if (s.includes('checking') || s.includes('review') || s.includes('pending')) return BadgeTone.Warning;
  if (s.includes('transit') || s.includes('delivery') || s.includes('placed')) return BadgeTone.Info;
  return BadgeTone.Neutral;
};

export const ordersTableColumns = (
  intl: IntlShape,
  isAllowedPrinter: boolean
): ColumnDef<GetOrdersResponseSingleItem>[] => [
  ...(isAllowedPrinter
    ? [
        {
          id: 'select-col',
          header: ({ table }: { table: Table<GetOrdersResponseSingleItem> }) => (
            <div className='px-1'>
              <IndeterminateCheckbox
                {...{
                  checked: table.getIsAllRowsSelected(),
                  indeterminate: table.getIsSomeRowsSelected(),
                  onChange: table.getToggleAllRowsSelectedHandler(),
                }}
              />
            </div>
          ),
          cell: ({ row }: { row: Row<GetOrdersResponseSingleItem> }) => (
            <div className='px-1'>
              <IndeterminateCheckbox
                {...{
                  checked: row.getIsSelected(),
                  disabled: !row.getCanSelect(),
                  indeterminate: row.getIsSomeSelected(),
                  onChange: row.getToggleSelectedHandler(),
                }}
              />
            </div>
          ),
        },
      ]
    : []),
  {
    // col 1: CUSTOMER — 28px OKLCH avatar + name, dir auto so Latin names stay LTR
    header: intl.formatMessage({ id: 'orders.customerName', defaultMessage: 'Customer' }),
    accessorKey: 'name',
    size: 180,
    cell: ({ cell: { getValue } }) => {
      const name = getValue() as string;
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, overflow: 'hidden' }}>
          <TableAvatar name={name} />
          <span
            className='ar'
            dir='auto'
            style={{
              fontWeight: 600,
              fontSize: 'var(--t-md)',
              color: 'var(--ink)',
              lineHeight: 1.35,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1,
              minWidth: 0,
            }}
          >
            {name || '—'}
          </span>
        </div>
      );
    },
  },
  {
    // col 2: UPDATED — formatDateShort(lastUpdatedAt), title = exact timestamp
    header: intl.formatMessage({ id: 'orders.updated', defaultMessage: 'Updated' }),
    accessorKey: 'lastUpdatedAt',
    size: 120,
    cell: ({ cell: { getValue } }) => {
      const date = new Date(getValue() as string);
      if (!isValid(date)) return <span style={{ color: 'var(--muted)' }}>—</span>;
      const exact = format(date, 'dd/MM/yyyy HH:mm');
      return (
        <span title={exact} style={{ cursor: 'default', color: 'var(--ink)' }}>
          {formatDateShort(date, intl.locale)}
        </span>
      );
    },
  },
  {
    // col 4: PHONE — mono, ltr, formatted
    header: intl.formatMessage({ id: 'orders.customerPhone', defaultMessage: 'Phone' }),
    accessorKey: 'phoneNumber',
    size: 150,
    cell: ({ cell: { getValue } }) => {
      const phone = getValue() as string;
      if (!phone) return <span style={{ color: 'var(--muted)' }}>—</span>;
      const formatted = formatIraqPhone(phone);
      return (
        <a
          href={`tel:${phone}`}
          title={phone}
          onClick={(e) => e.stopPropagation()}
          style={{
            display: 'inline-block',
            direction: 'ltr',
            color: 'var(--ink)',
            textDecoration: 'none',
            fontFamily: 'var(--font-mono)',
            fontVariantNumeric: 'tabular-nums',
            fontSize: 'var(--t-sm)',
          }}
        >
          {formatted}
        </a>
      );
    },
  },
  {
    // col 5: CITY — canonical label via cityLabel
    header: intl.formatMessage({ id: 'orders.city', defaultMessage: 'City' }),
    accessorKey: 'city',
    size: 120,
    cell: ({ cell: { getValue } }) => {
      const city = getValue() as string;
      if (!city) return <span style={{ color: 'var(--muted)' }}>—</span>;
      return <span style={{ color: 'var(--ink)', fontSize: 'var(--t-md)' }}>{cityLabel(city, intl.locale as 'en' | 'ar')}</span>;
    },
  },
  {
    // col 6: RECEIPT — single mono string, 13px
    header: intl.formatMessage({ id: 'orders.receiptNo', defaultMessage: 'Receipt' }),
    accessorKey: 'receiptNumber',
    size: 160,
    cell: ({ cell: { getValue } }) => {
      const receipt = getValue() as string;
      if (!receipt) return <span style={{ color: 'var(--muted)' }}>—</span>;
      return (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontVariantNumeric: 'tabular-nums',
            fontSize: 'var(--t-sm)',
            color: 'var(--ink-2)',
            whiteSpace: 'nowrap',
          }}
        >
          {receipt}
        </span>
      );
    },
  },
  {
    // col 7: STATUS — badge with dot
    header: intl.formatMessage({ id: 'orders.orderStatus', defaultMessage: 'Status' }),
    accessorKey: 'status',
    size: 130,
    cell: ({ cell: { getValue } }) => {
      const { options } = useStatusOptions();
      const statusVal = getValue() as string;
      const match = options.find((option) => option.value === statusVal);
      const label = match?.label ?? statusVal;
      const tone = statusTone(statusVal);
      return <Badge tone={tone} dot>{label || statusVal}</Badge>;
    },
  },
  {
    // col 8: VALUE — bold number + IQD suffix, right-aligned mono
    header: () => (
      <div style={{ textAlign: 'right' }}>
        {intl.formatMessage({ id: 'orders.value', defaultMessage: 'Value' })}
      </div>
    ),
    accessorKey: 'value',
    size: 120,
    cell: ({ cell: { getValue } }) => {
      const val = getValue() as number;
      if (val === null || val === undefined) return <span style={{ color: 'var(--muted)' }}>—</span>;
      return (
        <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', gap: 4 }}>
          <strong
            style={{
              fontFamily: 'var(--font-mono)',
              fontVariantNumeric: 'tabular-nums',
              fontWeight: 700,
              fontSize: 'var(--t-md)',
              color: 'var(--ink)',
            }}
          >
            {formatIqd(val)}
          </strong>
          <span
            style={{
              fontSize: 'var(--t-xs)',
              color: 'var(--muted)',
              fontFamily: 'var(--font-mono)',
              fontWeight: 500,
            }}
          >
            IQD
          </span>
        </span>
      );
    },
  },
];
